<template>
  <main>
    <v-card-title>
      <div class="header">
        <span>Unregistered eHubs</span>
        <v-text-field
          class="text-field"
          v-model="ehubSearch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </div>
    </v-card-title>
    <!-- UNREGISTERED EHUB LIST -->
    <v-data-table
      :headers="headers"
      :search="ehubSearch"
      :items="unregisteredEhubs"
      :loading="$apollo.queries.unregisteredEhubs.loading"
      hide-default-footer
      disable-pagination
      item-key="id"
    >
      <template v-slot:item.lastSeen="{ item }">
        <div class="d-flex flex-row flex-wrap">
          <span>{{
            item.statusJsonData
              ? new Date(
                  item.statusJsonData.lastConnectedAt,
                ).toLocaleDateString()
              : 'Never'
          }}</span>
          <span v-if="item.statusJsonData" class="ml-2 text--secondary">
            ({{ daysSince(new Date(item.statusJsonData.lastConnectedAt)) }} days
            ago)</span
          >
        </div>
      </template>
    </v-data-table>
  </main>
</template>

<script>
import { GET_UNREGISTERED_UNITS } from '../../graphql/ownerManagementQueries';
import { calendarDaysBetween } from '../../utils/DateTimeUtils';
export default {
  data() {
    return {
      unregisteredEhubs: [],
      ehubSearch: '',
      // Tables
      headers: [
        { text: 'name', value: 'statusJsonData.rangeInfo.name', align: 'left', sortable: false },
        { text: 'ID', value: 'id', align: 'left', sortable: false },
        { text: 'language', value: 'statusJsonData.rangeInfo.language', align: 'left', sortable: false },
        { text: 'timezone', value: 'statusJsonData.rangeInfo.timeZone', align: 'left', sortable: false },
        { text: 'release version', value: 'statusJsonData.rangeInfo.installedReleaseBundle', align: 'left', sortable: false },
        {
          text: 'Last seen',
          value: 'lastSeen',
          align: 'left',
          sortable: false,
        },
      ],
    };
  },
  apollo: {
    $client: 'ownerManagementClient',
    unregisteredEhubs: {
      query: GET_UNREGISTERED_UNITS,
      variables() {
        return {
          unitType: 'EHUB',
        };
      },
      update: (data) => data.getUnregisteredUnits,
    },
  },
  methods: {
    daysSince(date) {
      return calendarDaysBetween(date, new Date());
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.text-field {
  max-width: 300px;
}
</style>
